import { create } from "zustand";

type ReactQueryDevtoolsStore = {
	isOpen: boolean;
	open: () => void;
	close: () => void;
};

export const useReactQueryDevtoolsStore = create<ReactQueryDevtoolsStore>((set) => ({
	isOpen: false,
	open() {
		set({ isOpen: true });
	},
	close() {
		set({ isOpen: false });
	},
}));
